<template>
  <div class="coach-detail-show-page">
    <header-component></header-component>
    <div class="cdsp-content" v-loading="allLoading">
      <div class="header">
        <div v-if="personInfo.extra_info.avatar" class="img-person">
          <img :src="personInfo.extra_info.avatar" />
        </div>
        <div v-else class="img-person no-img">{{ personInfo.first_name[0] }}</div>
        <div class="button-box">
          <div v-if="!editflag" @click="editflag = true" class="leapin-primary-huge-button edit-but">
            <span><img :src="edit" /> Edit</span>
          </div>
          <div v-else @click="editflag = false" class="leapin-primary-huge-button edit-but">
            <span>Back</span>
          </div>
        </div>
      </div>
      <!-- 人员信息 -->
      <div v-if="!editflag" class="person-info-content">
        <!-- 基础信息 -->
        <div class="person-base-info">
          <div class="pic-title"> 
            <span class="name">{{ personInfo.first_name }}  {{ personInfo.last_name }}</span>
          </div>

          <div class="pic-info">
            <div class="info-item">
              <img :src="emailSvg" /> {{ personInfo.email }}
            </div>
            <div class="info-item">
              <img :src="xSvg" /> {{ getEmptyBack(personInfo.extra_info.twitter) }}
            </div>
            <div class="info-item">
              <img :src="insSvg" /> {{ getEmptyBack(personInfo.extra_info.linkedin) }}
            </div>
          </div>

          <div class="pic-info">
            <div class="info-item">
              <img :src="phoneSvg" />
              {{ $store.state.user.userInfo.mobile_country_code }} -
              {{ $store.state.user.userInfo.mobile }}
            </div>
            <div class="info-item">
              <img :src="earthSvg" /> {{ getEmptyBack(personInfo.extra_info.personal_website) }}
            </div>
            <div class="info-item">
              
            </div>
          </div>

          <!-- <div class="pic-info">
            <div class="info-item">
              <img :src="locationSvg" /> {{ getEmptyBack(personInfo.extra_info.intention_address) }}
            </div>
            <div class="info-item">
            </div>
            <div class="info-item">
              <img :src="xSvg" /> {{ getEmptyBack(personInfo.extra_info.twitter) }}
            </div>
          </div> -->
        </div>
        <!-- Summary、language、Video -->
        <div class="summary-info">
          <div class="si-left">
            <!-- 其他信息展示 -->
            <div class="other-info">
              <!-- 内容项展示-start -->
              <div class="oi-item" v-for="(item,index) in infoItemList" :key="index">
                <div class="leapin-air-title">
                  <img :src="linkAir" />{{ item.title }}</div>
                <div class="content-show" v-if="item.type == 'list'">
                  <div class="leapin-tags leapin-purple">
                    {{ getListValueBack(item.value,item.list) }}
                  </div>
                </div>
                <div class="content-show" v-else-if="item.type == 'enterList'">
                  <!-- <div v-if="item.field == 'languages'" class="leapin-tags leapin-purple" v-for="(child,i) in item.value" :key="i">
                    {{ child }}
                  </div> -->
                  <div class="leapin-tags leapin-purple" v-for="(child,i) in item.value" :key="i">
                    <span v-if="item.field == 'languages' || item.field == 'coach_type' || item.field == 'target_audience'">
                      {{ getListValueBack(child,item.list) }}
                    </span>
                    <span v-else>{{ child }}</span>
                  </div>
                </div>
                <div class="content-show" v-else>
                  <pre>{{ getEmptyBack(item.value) }}</pre>
                </div>
              </div>
              <!-- 内容项展示-end -->
            </div>

            <!-- 证书展示 -->
            <div class="certificate-box">
              <div class="item-title"><img :src="linkAir" /> CERTIFICATES</div>
              <Certificates :certList="personInfo.extra_info.credentials"></Certificates>
            </div>

            <!-- 预约时间展示 -->
            <div class="other-info">
              <div class="item-title"><img :src="linkAir" />  Available Time</div>
              <div class="oi-item">
                <div class="available-title">Select a Date & Time:</div>
                <div class="available-time">
                  <div v-for="(item,index) in personInfo.extra_info.schedule" :key="index">
                    <span class="leapin-ml-6">{{ item.start_time }}</span> - <span class="leapin-ml-6">{{ item.end_time }}</span>
                  </div>
                </div>
              </div>
              <div class="oi-item">
                <div class="available-title">Time zone:</div>
                <div class="available-time">
                  <span>
                    {{ personInfo.extra_info.timezone }}
                  </span>
                </div>
              </div>
              <div class="oi-item">
                <div class="available-title">Charging Rate:</div>
                <div class="available-time">
                  <span>
                    {{ personInfo.extra_info.charge_currency }} - {{ personInfo.extra_info.charge_rate }}
                  </span>
                </div>
              </div>
              <div class="oi-item">
                <div class="available-title">How many free trail session are you offering:</div>
                <div class="available-time">
                  <span>
                    {{ personInfo.extra_info.free_trial_count }}
                  </span>
                </div>
              </div>

            </div>

          </div>
          <div class="si-right">
            <div class="item-title">
              <img :src="linkAir" /> Video
            </div>
            <video
              controls
              class="video-box"
              :src="personInfo.extra_info.introduce_video_url">
              </video>
          </div>
        </div>
      </div>
      <info-form-coach v-else :editType="1" @updateInfo="updateInfo" @scrollToTop="scrollToTop"></info-form-coach>

    </div>

  </div>
</template>

<script>
import { getUserInfo } from '@/services/user';
import { COACH_CODE }  from '@/constants/coachCode'
import { TARGET_AUDIENCE_CODE } from '@/constants/targetAudience'
import { LANGUAGE_CODE } from '@/constants/languages'
export default {
  components: {
    HeaderComponent: () => import('@/components/header/Header.vue'),
    Certificates: () => import('@/views/coach/components/certificates.vue'),
    InfoFormCoach: () => import('@/views/coach/components/infoFormCoach.vue'),
  },
  name: 'CoachShow',
  data() {
    return {
      allLoading: false,
      editflag: false,
      videoSrc: '',
      edit: require('@/assets/svgs/edit.svg'),
      linkAir: require('@/assets/svgs/link-air.svg'),
      locationSvg: require('@/assets/svgs/location.svg'),
      linkAirWhite: require('@/assets/svgs/link-air-white.svg'),
      star: require('@/assets/svgs/star.svg'),
      coachDetailBg1: require('@/assets/images/coach/coach-detail-bg1.png'),
      peopleImg: require('@/assets/images/users/candidate5.png'),
      earthSvg: require('@/assets/svgs/coach/earth.svg'),
      emailSvg: require('@/assets/svgs/coach/email.svg'),
      facebookSvg: require('@/assets/svgs/coach/facebook.svg'),
      insSvg: require('@/assets/svgs/coach/ins.svg'),
      phoneSvg: require('@/assets/svgs/coach/phone.svg'),
      shipSvg: require('@/assets/svgs/coach/ship.svg'),
      xSvg: require('@/assets/svgs/coach/x.svg'),
      credentialsInputValue: '',
      languagesCodeList: LANGUAGE_CODE,
      targetAudienceList: TARGET_AUDIENCE_CODE,
      coachCodeList: COACH_CODE,
      personInfo: {extra_info: {},first_name: '',last_name: '',email: '',mobile: ''},
      
      infoItemList: [
        {
          title: 'Summary',
          value: '',
          type: 'enter',
          field: 'description',
        },
        {
          title: "Type of coach",
          list: [],
          value: 0,
          field: 'coach_type',
          type: 'enterList',
        },
        {
          title: 'Years of coaching experience',
          value: '',
          type: 'enter',
          field: 'work_year',
        },
        {
          title: "Target audience",
          list: [],
          value: 0,
          field: 'target_audience',
          type: 'enterList',
        },
        {
          title: "Specialities",
          value: '',
          type: 'enterList',
          field: 'specialities',
        },
        {
          title: "Languages",
          list: [],
          value: 0,
          field: 'languages',
          type: 'enterList',
        },
        {
          title: 'Work experience',
          value: '',
          type: 'enter',
          field: 'work_experience',
        },
        {
          title: 'Education',
          value: '',
          type: 'enter',
          field: 'education',
        },
        // {
        //   title: "Cerdentials",
        //   value: '',
        //   type: 'enterList',
        //   field: 'credentials',
        // },
      ],
      
    }
  },
  mounted () {
    this.getReportInfo();
    this.infoItemList.forEach((e) => {
      if (e.field == 'coach_type') {
        e.list = this.coachCodeList;
      }
      if (e.field == 'target_audience') {
        e.list = this.targetAudienceList;
      }
      if (e.field == 'languages') {
        e.list = this.languagesCodeList;
      }
    });
    
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    // 完成修改
    updateInfo() {
      this.editflag = false;
      this.getReportInfo();
    },
    //获取登陆人信息
    getReportInfo() {
      this.allLoading = true;
      getUserInfo({}).then((res) => {
        this.allLoading = false;
        if (res.code == 0) {
          this.$store.dispatch("user:userinfo", res.data);
          this.personInfo = res.data;
          this.infoItemList.forEach((e) => {
            e.value = this.personInfo.extra_info[e.field];
          });
        } else {
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.allLoading = false;
        this.$message.error(err.message);
      });
    },
    // 获取列表Lael返回
    getListValueBack(value, list) {
      let result = '';
      list.forEach((e) => {
        if (e.value == value) {
          result = e.name;
        }
      });
      return result;
    },


  }
}
</script>
<style scoped lang="scss">
.coach-detail-show-page {
  background: url('../../assets/images/coach/coach-detail-bg1.png') no-repeat;
  background-position: top center;
  width: 100%;
  .cdsp-content {
    margin: 0 152px;
    position: relative;
    top: 105px;
    .header {
      height: 190px;
      position: relative;
      .img-person {
        position: absolute;
        width: 130px;
        height: 130px;
        object-fit: cover;
        bottom: 15px;
        left: 34px;
        border-radius: 100px;
        padding: 4px;
        background: #fff;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 100px;
        }
      }
      .no-img {
        background: #6E62E5;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 50px;
      }
      .button-box {
        position: absolute;
        bottom: 0;
        right: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0 10px;
        .edit-but {
          padding: 6px 50px !important;
        }
      }
    }
    .person-info-content {
      padding: 0 32px 70px 32px;
      font-family: "PingFang SC";
      .person-base-info {
        padding-bottom: 10px;
        border-bottom: 1px solid #E5E5E5;
        .pic-title {
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            color: #000;
            font-family: Poppins;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 6px;
          }
        }
        .pic-info {
          color: #000;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 16px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .info-item {
            width: 33%;
            margin-right: 32px;
          }
          span {
            color: #6E62E5;
          }
        }
      }
      .item-title {
        color: #000;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 14px;
        font-family: "PingFang SC";
        display: flex;
        align-items: center;
        justify-content: flex-start;
        letter-spacing: 0.5px;
        img {
          width: 18px;
          height: 18px;
          margin-right: 8px;
        }
      }
      .summary-info {
        display: flex;
        justify-content: space-between;
        gap: 0 24px;
        margin-top: 24px;
        .si-left {
          flex-grow: 1;
          .text {
            padding: 12px;
            color: #999;
            font-family: "PingFang SC";
            font-size: 14px;
            border-radius: 2px;
            background: #FFF;
            border: 1px solid #E6E8F0;
            margin-bottom: 24px;
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            justify-content: flex-start;
            align-items: flex-start;
          }
          .full {
            min-height: 220px;
            margin-bottom: 0px !important;
          }
          .other-info {
            margin-top: 24px;
            .oi-item {
              display: flex;
              padding: 16px;
              flex-direction: column;
              align-items: flex-start;
              gap: 12px;
              align-self: stretch;
              background: #f8f9fb;
              border-radius: 12px;
              margin-bottom: 20px;
              .stress {
                color: #000 !important;
              }
              .item-top {
                width: 100%;
                margin-bottom: 4px;
                border-bottom: 1px solid #E5E5E5;
              }
              .content-show {
                margin-left: 25px;
                display: flex;
                gap: 6px;
                justify-content: flex-start;
                align-items: flex-start;
                font-size: 14px;
                color: #000;
                font-weight: 100;
                font-size: 15px;
                pre {
                  font-family: 'PingFang SC';
                }
              }
              .available-title {
                color: #000;
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 10px;
              }
              .available-time {
                display: flex;
                flex-direction: column;
                gap: 12px;
                justify-content: flex-start;
                align-items: center;
                span {
                  color: #000;
                  font-size: 15px;
                }
              }
            }
          }

          .certificate-box {
            margin-top: 24px;
            padding-top: 24px;
            border-top: 1px solid #E5E5E5;
          }

        }
        .si-right {
          height: 100%;
          flex-grow: 0;
          border-radius: 12px;
          background: #F8F9FB;
          padding: 16px;
          .video-box {
            width: 384px;
            height: 254px;
            object-fit: cover;
          }
        }
      }
    }
  }
}
</style>
